

import { DialogGeneral } from "../utils/Dialog/dialog";
import { createUUID, createBoundingSphereFromLatLonBounds, colorIsolate } from "../utils/utils";
import "../styles/treeTileModel.css"
import { IconArrowDown, IconEyeHide, IconEyeShow, IconFilter, IconSearch } from "../icon";

import { getMessage } from '../language';
import { Cartesian3, HeadingPitchRange, Viewer, Math as CesiumMath, Cartographic } from "cesium";
import { SceneManager } from "./sceneManager";
import loading from "../assets/images/loading-roll-2.png"
import { ContextMenu } from "./contextMenu";
import { HyperList } from "../utils/hyperlist/hyperlist";
import { InputDataPrimitive } from "./styleElement";
import { ObjDataPrimitiveModel } from "src/interfaces/styleElement.interface";
import { FilterTree } from "./filterTree/filterLayerModel";





export class LayerModelNew {
    viewer: Viewer;
    containerId: string;
    IdGenneral = createUUID();//Tạo ID ngẫu nhiên khi khởi tạo
    modal: any
    treeLayerModels: any[] = [];
    contextMenu: ContextMenu | undefined
    listKeyMapObject: Record<string, Partial<any>> | undefined = undefined;
    inputDataPrimitive: InputDataPrimitive | undefined = undefined
    // private _buttonsMap = new Map<string, HTMLElement>()
    private _buttonsMapHide = new Map<string, any>()

    private isOpenModal: boolean = false;
    private _sceneManager: SceneManager | undefined
    token: string | undefined
    private dialog: DialogGeneral | undefined;
    private _primitiveNames: string[] = []

    // Thuộc tính để lưu callback
    private onClosedCallback: ((status: boolean) => void) | undefined;
    constructor(containerId: string, viewer: any, token: string, sceneManager: SceneManager, contextMenu: ContextMenu) {
        this.containerId = containerId; // Gán giá trị containerId    
        this.viewer = viewer;//Gán giá trị viewer
        this.token = token
        this._sceneManager = sceneManager
        this.contextMenu = contextMenu
        this.createModalTreeLayerModel()
        this.dialog?.showModal(false)



    }
    private _list: HyperList | undefined
    private _config = {
        height: '100%',
        itemHeight: 33,
        total: 50,
        reverse: false,
        scrollerTagName: 'div',
        // Customize the virtual row class, defaults to vrow.
        rowClassName: 'dpu-tree-item',
        generate: (row: number): HTMLDivElement => {
            const item = this.listDisplayItem[row];
            const div = this.createItemTag(item, this.listDisplayItem) as HTMLDivElement;
            return div ?? document.createElement('div'); // Ensure a valid HTMLElement is always returned
        }
    }
    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean) => void): void {
        this.onClosedCallback = callback;
    }
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status); // Thông báo cho lớp cha
        } else {
            console.error("State change callback is not set.");
        }
    }


    /**
   * Hàm khởi tạo popup modal
   */


    createModalTreeLayerModel = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = getMessage('layer-title-dialog');
        this.dialog.modal = false
        this.dialog.minimizeDialog = true;
        this.dialog.widthModal = '300px'
        this.dialog.heightModal = '500px'
        this.dialog.zIndex = 101
        this.dialog.topModal = '5px'
        this.dialog.leftModal = '5px'
        // Lấy chuỗi HTML của tree view và gán cho innerBody
        this.dialog.innerBody = this.renderTreeLayerModel();
        this.dialog.innerFooter = this.renderFooter();
        this.dialog.createDialog();
    }
    //#region showHideModalTreeLayerModel
    showHideModalTreeLayerModel = (show: boolean) => {
        if (show) {
            this.isOpenModal = true
            //Kiểm tra có tồn tài condition
            this._actionCheckCoditionContextMenu()
        } else {
            this.isOpenModal = false
            // this._actionShowAllBtn()
        }
        this.dialog?.showModal(show)

    }


    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status)
        }
        this.isOpenModal = status
    }


    private containerUl: HTMLElement | undefined

    private _idTreeView = `list-tree-${this.IdGenneral}`

    //#region  renderTreeLayerModel
    // Hàm renderTreeView
    containerDialog: HTMLElement | undefined
    renderTreeLayerModel = (): HTMLElement => {

        // Nếu containerUl đã tồn tại, remove nó khỏi DOM
        if (this.containerUl) {
            this.clearContainer()
        } else {

            this.containerUl = document.createElement('div');
            this.containerUl.id = this._idTreeView;
            this.containerUl.className = "container-treelist";

        }

        //Render ra tree layer
        this.handleDisplayItem()

        this.createTreeItem(this.listDisplayItem)


        return this.containerUl;
        // return this.containerDialog!;
    };
    //#region renderFooter
    private containerFooter: HTMLElement | undefined
    renderFooter = (): HTMLElement => {

        this.containerFooter = document.createElement('div');
        this.containerFooter.id = `footer-tree-folder-${this.containerId}`;

        this.containerFooter.style.marginTop = '5px';
        const settingBtn = document.createElement('button');
        settingBtn.id = `btn-move-model-${this.IdGenneral}`;
        settingBtn.className = 'DPU-btn-defaut-style';
        settingBtn.style.marginRight = '5px';
        settingBtn.innerHTML = IconFilter()
        this.containerFooter.appendChild(settingBtn)

        if (settingBtn) {
            settingBtn.addEventListener('click', () => {
                this._handleFilterTree()
            });
        }


        return this.containerFooter;
    }

    private clearContainer = () => {
        if (this.containerUl) {
            this.containerUl.innerHTML = ""; // Xóa nội dung bên trong containerUl
        }
    };
    //#region _handleDisplayItem
    listDisplayItem: any[] = [] // Lưu trữ các item được hiển thị
    handleDisplayItem = (startItem?: any) => {
        if (!this.treeLayerModels) return;

        if (!startItem) {
            // Nếu không có startItem, build từ root
            this.listDisplayItem = [];

            const rootItems = this.treeLayerModels.filter(item => item.parent === null || item.parent === undefined);

            // Set level cho root
            rootItems.forEach(root => {
                root.level = 0;
                this.listDisplayItem.push(root);
            });

            // Duyệt từng phần tử để xử lý expand
            let index = 0;
            while (index < this.listDisplayItem.length) {
                const currentItem = this.listDisplayItem[index];
                if (currentItem.expand) {
                    const children = this.treeLayerModels.filter(item => item.parent === currentItem.objectId);
                    children.forEach(child => {
                        child.level = currentItem.level + 1;
                    });
                    // currentItem.childrenObject = children;
                    this.listDisplayItem.splice(index + 1, 0, ...children);
                }
                index++;
            }

        } else {

            // Tìm vị trí startItem
            const startIndex = this.listDisplayItem.findIndex(item => item.objectId === startItem.objectId);
            if (startIndex !== -1) {
                const children = this.treeLayerModels.filter(item => item.parent === startItem.objectId);
                children.forEach(child => {
                    child.level = (startItem.level || 0) + 1;
                    if (!startItem.isShow) {
                        this._buttonsMapHide.set(child.objectId, child); // Thêm vào map nếu không hiển thị
                    }
                });


                // Thêm children vào ngay sau startItem
                this.listDisplayItem.splice(startIndex + 1, 0, ...children);

                // Tạo stack để duyệt cây con
                let stack = [...children];

                while (stack.length > 0) {
                    const currentItem = stack.shift();
                    if (currentItem.expand) {
                        const grandChildren = this.treeLayerModels.filter(item => item.parent === currentItem.objectId);
                        grandChildren.forEach(gc => {
                            gc.level = (currentItem.level || 0) + 1;
                        });

                        // Thêm grandChildren vào sau currentItem
                        const currentIndex = this.listDisplayItem.findIndex(item => item.objectId === currentItem.objectId);
                        this.listDisplayItem.splice(currentIndex + 1, 0, ...grandChildren);

                        // Thêm vào stack để duyệt tiếp nếu expand
                        stack.unshift(...grandChildren);
                    }
                }
            }
        }
    }
    //#region _handleRemoveDisplayItem
    handleRemoveDisplayItem = (parentItem: any) => {
        if (!this.treeLayerModels || !this.listDisplayItem) return;

        // Build a parent-to-children Map for O(N) lookup
        const parentMap = new Map<string, any[]>();
        this.treeLayerModels.forEach(item => {
            if (item.parent !== null && item.parent !== undefined) {
                if (!parentMap.has(item.parent)) {
                    parentMap.set(item.parent, []);
                }
                parentMap.get(item.parent)!.push(item);
            }
        });

        // Collect all descendant objectIds to remove
        const toRemove = new Set<string>();
        const stack = [parentItem.objectId];
        while (stack.length > 0) {
            const currentId = stack.pop()!;
            const children = parentMap.get(currentId);
            if (children) {
                children.forEach(child => {
                    if (!toRemove.has(child.objectId)) {
                        toRemove.add(child.objectId);
                        stack.push(child.objectId);
                    }
                });
            }
        }

        // Filter listDisplayItem in a single O(L) pass
        this.listDisplayItem = this.listDisplayItem.filter(item => !toRemove.has(item.objectId));
    }

    private selectedItems: Set<string> = new Set(); // Lưu trữ các ID đã được chọn

    private createTreeItem = (flatData: any[]) => {
        flatData.forEach((currentItem: any) => {
            const div = this.createItemTag(currentItem, flatData)
            if (div) {
                this.containerUl!.appendChild(div);
            }
        })
    }

    private _listItemMap: Map<string, any> = new Map<string, any>()
    private createItemTag = (currentItem: any, flatData: any[]) => {
        if (!currentItem) return
        this._listItemMap.set(currentItem.objectId, currentItem)
        const div = document.createElement('div');
        div.className = "dpu-tree-item";
        div.setAttribute('data-layer-id', currentItem.objectId);
        if (currentItem.level || currentItem.level !== 0) {
            div.setAttribute('data-level', currentItem.level);
            div.style.paddingLeft = `${currentItem.level * 15}px`;
        }
        const fullrow = document.createElement('div');
        fullrow.className = "fullrow";
        div.appendChild(fullrow);



        div.addEventListener('click', (event) => this.handleItemSelection(event, div, currentItem));

        const children = flatData.filter(item => item.parent === currentItem.objectId);

        if (children.length > 0) {
            currentItem.isFolder = true
            currentItem.childrenObject = children;
        }
        //Tạo tất cả row
        const span = this.createCaretSpan(currentItem);
        div.appendChild(span);



        //Tạo nút visible/search
        const buttonContainer = this.createButtonContainer(currentItem, div);
        if (currentItem?.primitiveName === undefined && currentItem?.isLoadData === undefined) {
            if (currentItem.parent && !currentItem.parent.includes('first')) {
                div.appendChild(buttonContainer);
            }
        }
        if (this.isFilterTree || currentItem?.isLoadData) {
            div.appendChild(buttonContainer);

        }
        return div
    }

    //#region _getAllChildrenFlat
    private _getAllChildrenFlat = (flatData: any[], parentId: string): any[] => {
        const directChildren = flatData.filter(item => item.parent === parentId);
        let allChildren = [...directChildren];

        directChildren.forEach(child => {
            const childDescendants = this._getAllChildrenFlat(flatData, child.objectId);
            allChildren = allChildren.concat(childDescendants);
        });

        return allChildren;
    };

    //#region handleItemSelection
    /**
         * Xử lý sự kiện chọn mục
         */
    private handleItemSelection(event: MouseEvent, li: HTMLElement, currentItem: any): void {
        // const isCtrl = event.ctrlKey;
        // const isShift = event.shiftKey;

        // if (isCtrl) {
        //     this.toggleSelectItem(li, currentItem);
        //     return;
        // }

        // if (isShift && this.lastSelectedItem) {
        //     this.selectRange(li, currentItem);
        //     return;
        // }

        this.selectSingleItem(li, currentItem);
    }



    //#region selectSingleItem
    /**
     * Chọn một mục duy nhất
     */
    private selectSingleItem(li: HTMLElement, currentItem: any): void {
        const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
        allTreeItems.forEach(item => item.classList.remove('active'));

        li.classList.add('active');
        this.selectedItems.clear();
        this.selectedItems.add(currentItem.id);
    }



    /**
     * Tạo span chứa caret và màu
     */
    private createCaretSpan(currentItem: any): HTMLSpanElement {
        const span = document.createElement('span');
        span.className = "caret";
        //Tạo arrow
        this.createNestedContainer(currentItem, span)

        const textNode = document.createElement('span');
        textNode.className = "text";
        textNode.setAttribute('data-layer-text-id', currentItem.objectId);
        textNode.textContent = (currentItem.name === "") ? currentItem.type || "" : currentItem.name;
        if (currentItem.isShow === false) {
            textNode.style.opacity = "0.5"
        }
        span.appendChild(textNode);

        return span;
    }

    //#region createNestedContainer
    /**
     * Tạo container cho mục con
     */

    private createNestedContainer(currentItem: any, span: HTMLElement) {
        const spanHolder = document.createElement('span');
        if (currentItem.isFolder || currentItem.level == 0 || currentItem.childrenObject?.length > 0) {
            spanHolder.className = "arrow-icon";
            if (currentItem.isLoading) {
                spanHolder.style.pointerEvents = "none";
                spanHolder.innerHTML = ` <img class = "dpu-loading-animation" src="${loading}" alt="Loading..." width="14" height ="14"  style="pointer-events: none;"/>`;
            } else {
                spanHolder.innerHTML = IconArrowDown();
                if (currentItem.expand === undefined || currentItem.expand === null) {
                    currentItem.expand = false;
                }
                if (currentItem.expand) {
                    spanHolder.classList.add("arrow-down");
                } else {
                    spanHolder.classList.remove("arrow-down");
                }
                spanHolder.addEventListener("click", (event) => {
                    event.stopPropagation();
                    this._actionArrow(currentItem, spanHolder);
                });
            }

        } else {
            spanHolder.className = "arrow-placeholder";

        }



        span.appendChild(spanHolder);


        // children.forEach(child => {
        //     const childItem = this.createTreeItem(flatData, child);
        //     nestedContainer.appendChild(childItem);
        // });

    }
    //#region actionArrow
    private _actionArrow = async (currentItem: any, arrow: HTMLSpanElement) => {
        if (!this.isFilterTree) {
            if (currentItem?.primitiveName && !currentItem.isLoadData) {
                arrow.style.pointerEvents = "none";
                currentItem.isLoading = true;
                arrow.innerHTML = ` <img class = "dpu-loading-animation" src="${loading}" alt="Loading..." width="14" height ="14"  style="pointer-events: none;"/>`;

                const result = await this._handleCallApiTree(currentItem);
                currentItem.isLoading = false;
                if (result) {
                    currentItem.expand = true;
                    arrow.innerHTML = IconArrowDown();

                    this._calConditionForTree()

                    this.handleDisplayItem(currentItem)
                    if (this.containerUl && !this._list) {
                        // const height = this.containerUl?.getBoundingClientRect().height || window.innerHeight;
                        this._config.total = this.treeLayerModels.length
                        this._list = new HyperList(this.containerUl!, this._config)
                    }
                    this._config.total = this.listDisplayItem.length
                    this._list?.refresh(this.containerUl!, this._config)



                } else {
                    // arrow.classList.toggle("arrow-down");
                    arrow.innerHTML = IconArrowDown();
                    currentItem.expand = false

                }
                arrow.style.pointerEvents = "auto";

            } else {

                if (!currentItem.expand) {
                    currentItem.expand = true
                    if (this.containerUl && !this._list) {
                        // const height = this.containerUl?.getBoundingClientRect().height || window.innerHeight;
                        this._config.total = this.treeLayerModels.length
                        this._list = new HyperList(this.containerUl!, this._config)
                    }
                    this.handleDisplayItem(currentItem)
                    this._config.total = this.listDisplayItem.length
                    this._list?.refresh(this.containerUl!, this._config)

                } else {
                    currentItem.expand = false
                    this.handleRemoveDisplayItem(currentItem)
                    this._config.total = this.listDisplayItem.length
                    this._list?.refresh(this.containerUl!, this._config)

                }
                // arrow.classList.toggle("arrow-down");
            }
        } else {
            await this._filterTree?.handleActionArrowForFilterDetailData(currentItem, arrow)
        }


    }
    private _handleCallApiTree = async (currentItem: any): Promise<boolean> => {
        try {
            const checkPrimitive = this._primitiveNames.find(x => x === currentItem.primitiveName)

            if (checkPrimitive) return false
            this._primitiveNames.push(currentItem.primitiveName)

            const workerCode = `
                self.onmessage = async function(e) {
                    const { url, token, primitiveName } = e.data;
                    try {
                        const response = await fetch(url, {
                            method: "POST",
                            headers: {
                                'accept': 'text/plain',
                                'Authorization': 'Bearer ' + token,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                primitives: [primitiveName]
                            })
                        });

                        if (!response.ok) {
                            self.postMessage({ success: false, error: 'Response not ok' });
                            return;
                        }

                        const result = await response.json();
                        self.postMessage({ success: true, data: result.data || [] });
                    } catch (err) {
                        self.postMessage({ success: false, error: err.message });
                    }
                };
            `;

            const blob = new Blob([workerCode], { type: 'application/javascript' });
            const workerUrl = URL.createObjectURL(blob);
            const worker = new Worker(workerUrl);

            const resultPromise = new Promise<any>((resolve, reject) => {
                worker.onmessage = (e) => {
                    resolve(e.data);
                };
                worker.onerror = (e) => {
                    reject(e);
                };
            });

            worker.postMessage({
                url: `https://translateservicedev.corebim.com/queryTranslateApi/Translate/GetIFCStructure`,
                token: this.token,
                primitiveName: currentItem.primitiveName
            });

            const workerResult = await resultPromise;
            worker.terminate();
            URL.revokeObjectURL(workerUrl);

            if (workerResult && workerResult.success && workerResult.data.length > 0) {
                currentItem.isLoadData = true;
                const containerView = document.getElementById(`${this.containerId}`);
                const dataView = containerView?.querySelector(`[data-folder-id="${currentItem.objectId}"]`);
                if (dataView) {
                    const stringIcon = this._normalizeSVGString(IconEyeHide());
                    const currentIcon = this._normalizeSVGString(dataView.innerHTML);
                    if (currentIcon === stringIcon) {
                        (dataView as HTMLElement).click();
                    }
                }

                const tempListData = workerResult.data;

                // Synchronous O(N) tree updates on the main thread (No race conditions!)
                this.treeLayerModels = this.treeLayerModels.filter((item: any) => item.parent !== currentItem.objectId);
                const findItemParentNull = tempListData.filter((item: any) => item.parent === null || item.parent === undefined);
                if (findItemParentNull) {
                    findItemParentNull.forEach((item: any) => {
                        item.parent = currentItem.parent;
                        if (item.name === currentItem.name) {
                            this.treeLayerModels = this.treeLayerModels.filter((x: any) => x.objectId !== currentItem.objectId);
                        } else {
                            item.parent = currentItem.objectId;
                        }
                    });
                }
                this.treeLayerModels = [...this.treeLayerModels, ...tempListData];

                const parentMap = new Map<string, any[]>();
                this.treeLayerModels.forEach((tempItem: any) => {
                    this._listItemMap.set(tempItem.objectId, tempItem);
                    if (tempItem.parent !== null && tempItem.parent !== undefined) {
                        if (!parentMap.has(tempItem.parent)) {
                            parentMap.set(tempItem.parent, []);
                        }
                        parentMap.get(tempItem.parent)!.push(tempItem);
                    }
                });

                this.treeLayerModels.forEach((tempItem: any) => {
                    tempItem.childrenObject = parentMap.get(tempItem.objectId) || [];
                });

                return true;
            } else {
                this._primitiveNames = this._primitiveNames.filter(x => x !== currentItem.primitiveName);
                return false;
            }
        } catch (error) {
            this._primitiveNames = this._primitiveNames.filter(x => x !== currentItem.primitiveName);
            return false;
        }
    }


    //#region createButtonContainer
    /**
     * Tạo container cho các nút chức năng (ví dụ: tìm kiếm, xóa, chỉnh sửa)
     */
    private createButtonContainer(currentItem: any, li: HTMLElement): HTMLDivElement {
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'button-container';
        // Tạo nút tìm kiếm
        const showButton = document.createElement('div');
        showButton.className = 'folder-button';
        showButton.setAttribute('data-folder-id', currentItem.objectId.toString());
        if (currentItem.isShow === undefined) {
            currentItem.isShow = true
        }
        showButton.innerHTML = currentItem.isShow ? IconEyeShow() : IconEyeHide();
        showButton.addEventListener('click', (event) => {
            event.stopPropagation();


            this._handleToggleVisible(currentItem, showButton)


            // this.handleItemSelection(event, li, currentItem)
            // Làm nổi bật mục được chọn
            const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.remove('active'));
            const parentLi = searchButton.closest('.dpu-tree-item') as HTMLLIElement;
            parentLi?.classList.add('active');
        });

        // Thêm nút vào container
        buttonContainer.appendChild(showButton);
        // Tạo nút tìm kiếm
        const searchButton = document.createElement('div');
        searchButton.className = 'search-button';
        searchButton.innerHTML = IconSearch(); // Hàm tạo biểu tượng tìm kiếm
        searchButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this._handleZoomTo(currentItem)

            // this.zoomLabelPoint(currentItem);

            // Làm nổi bật mục được chọn
            const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.remove('active'));
            const parentLi = searchButton.closest('.dpu-tree-item') as HTMLLIElement;
            parentLi?.classList.add('active');
        });
        buttonContainer.appendChild(searchButton);




        return buttonContainer;
    }
    //#region _handleZoomTo
    private _handleZoomTo = async (dataView: any) => {
        // console.time('zoom-to')
        let maxPoint: [number, number, number] = [0, 0, 0];
        let minPoint: [number, number, number] = [0, 0, 0];
        const objectConect = this.listKeyMapObject?.[dataView.objectId]?.objectConnects

        if (!objectConect) {
            if (dataView.childrenObject.length > 0) {// không có thông tin cũng không là parent
                const pointParent = dataView.dataPoint
                if (pointParent) {
                    minPoint = [
                        pointParent.min.x, // lat
                        pointParent.min.y, // lon
                        pointParent.min.z  // height
                    ];
                    maxPoint = [
                        pointParent.max.x, // lat
                        pointParent.max.y, // lon
                        pointParent.max.z // height
                    ];
                }
            }
        }
        if (objectConect && objectConect.length > 0) {
            const url = this.listKeyMapObject?.[dataView.objectId].primitive.resource?.url
            const originalBoundingBox = this.listKeyMapObject?.[dataView.objectId].originalBoundingBox
            const disparityCood = this._handleDisparityCoord(url, originalBoundingBox)
            const pointObj = this.computeBoundingBoxFromFeatureObjects(objectConect)//kiểm tra xem nó có nhiều maxPoint minPonit
            if (!pointObj) return
            const tempList = [dataView]
            this._handleIsolate(tempList)

            minPoint = [
                pointObj.minPoint[0] + disparityCood[1],
                pointObj.minPoint[1] + disparityCood[0],
                pointObj.minPoint[2] + disparityCood[2]
            ]
            maxPoint = [
                pointObj.maxPoint[0] + disparityCood[1],
                pointObj.maxPoint[1] + disparityCood[0],
                pointObj.maxPoint[2] + disparityCood[2]
            ]


        }

        if (!this.isFilterTree && dataView.childrenObject.length > 0) {
            this._handleIsolateForParent(dataView)

        }

        if (this.isFilterTree && dataView.isFolder) {

            if (!dataView.dataPoint) {

                await this._filterTree?.computeGlobalPointAndCondition(dataView)
            }
            minPoint = [
                dataView.dataPoint.min[0],
                dataView.dataPoint.min[1],
                dataView.dataPoint.min[2]
            ];
            maxPoint = [
                dataView.dataPoint.max[0],
                dataView.dataPoint.max[1],
                dataView.dataPoint.max[2]
            ];
            this._handleIsolateForParent(dataView)

        }

        const checkMin = minPoint.some((v: number | null | undefined) => v === null || v === undefined || v === -Infinity || v === Infinity || v === 0)
        const checkMax = maxPoint.some((v: number | null | undefined) => v === null || v === undefined || v === -Infinity || v === Infinity || v === 0)
        if (checkMin || checkMax) return
        // Giữ nguyên vị trí hiện tại của camera
        const boundingSphere = createBoundingSphereFromLatLonBounds(minPoint, maxPoint);
        const pitch = this.viewer.camera.pitch;
        const roll = this.viewer.camera.roll;
        const heading = this.viewer.camera.heading; // Có thể giữ luôn heading nếu muốn

        const offset = new HeadingPitchRange(
            heading, // vẫn giữ nguyên
            pitch,   // giữ pitch cũ
            boundingSphere.radius * 2 + 10// hoặc tuỳ chỉnh độ zoom
        );
        this.viewer.camera.flyToBoundingSphere(boundingSphere, {
            duration: (dataView.childrenObject.length > 0) ? 0 : 0.5, // Thời gian bay
            offset: offset,
            complete: () => {
                // Bởi vì roll không được giữ qua offset, ta đặt lại roll sau khi fly xong
                this.viewer.camera.setView({
                    orientation: {
                        heading: this.viewer.camera.heading,
                        pitch: this.viewer.camera.pitch,
                        roll: roll // restore lại roll
                    }
                });
            }

        });
        this.contextMenu!.contextMenu_Isolate()
        this.contextMenu!.isLoadFromShow = false
        // console.timeEnd('zoom-to')

    }

    //#region _handleDisparityCoord
    private _handleDisparityCoord = (url: string, originalBoundingBox: Cartesian3) => {
        const disparityCoord = [
            0,
            0,
            0
        ]

        for (let i = 0; i <= this.viewer.scene.primitives.length; i++) {
            const primitive = this.viewer.scene.primitives.get(i)
            if (primitive?.resource?.url === url) {
                const currentCart = this._sceneManager?.getCurrentCartographic(primitive)
                // originalBoundingBox là đối tượng Cartesian3
                const cartographic = Cartographic.fromCartesian(originalBoundingBox);

                // Tính toán delta (độ thay đổi) từ vị trí cũ sang vị trí mới
                disparityCoord[0] = CesiumMath.toDegrees(currentCart!.longitude) - CesiumMath.toDegrees(cartographic.longitude);
                disparityCoord[1] = CesiumMath.toDegrees(currentCart!.latitude) - CesiumMath.toDegrees(cartographic.latitude);
                disparityCoord[2] = currentCart!.height - cartographic.height

            }

        }
        return disparityCoord
    }




    // private _conditionShowOff: [string, string][] = []
    //#region  _handleToggleVisible
    // Hàm xử lý khi nút bên trái được nhấn
    private _handleToggleVisible = async (dataView: any, button: HTMLElement) => {
        this.contextMenu!.isLoadFromShow = true

        dataView.isShow = !dataView.isShow


        button.innerHTML = dataView.isShow ? IconEyeShow() : IconEyeHide();
        if (!this.isFilterTree && dataView.childrenObject.length > 0) {
            this._handleShowOffForParent(dataView, dataView.isShow);
        }
        else if (this.isFilterTree && dataView.isFolder) {
            if (!dataView.dataPoint) {
                await this._filterTree?.computeGlobalPointAndCondition(dataView);
            }
            this._handleShowOffForParent(dataView, dataView.isShow);
        }
        else {
            this._handleShowOff(dataView, dataView.isShow);
        }


        // Check if [true, true] exists in _conditionShowOff and remove it
        this.contextMenu!.conditionShowOff = this.contextMenu!.conditionShowOff.filter(
            ([key, value]) => !(key === "true" && value === "true")
        );
        if (this.contextMenu!.conditionShowOff.length > 0) {
            this.contextMenu!.conditionShowOff.push(['true', 'true'])
        }
        this.contextMenu!.contextMenu_ShowOff()
        // Cập nhật lại nội dung nút dựa trên giá trị của isShow

        // Cập nhật trạng thái và icon cho tất cả các thư mục con (bao gồm cả cấp lồng nhau)
        // this._updateChildButtons(dataView);
        // this.viewer.scene.requestRender()

        this.contextMenu!.isLoadFromShow = false
    }
    //#region _handleShowOff
    private _handleShowOff = (dataView: any, show: boolean) => {
        if (!this.listKeyMapObject) {
            return;
        }
        const objectConects = this.listKeyMapObject![dataView.objectId]?.objectConnects
        const containerBtn = document.querySelector(`#${this._idTreeView}`)
        const button = containerBtn?.querySelector<HTMLElement>(`div[data-folder-id="${dataView.objectId}"]`);
        const text = containerBtn?.querySelector<HTMLElement>(`span[data-layer-text-id="${dataView.objectId}"]`);
        if (button && text) {
            if (show) {
                text.style.removeProperty('opacity')
                button.innerHTML = IconEyeShow()
                this._buttonsMapHide.delete(dataView.objectId)
            } else {
                text.style.opacity = "0.5"
                button.innerHTML = IconEyeHide()
                this._buttonsMapHide.set(dataView.objectId, dataView)
            }
        }
        if (objectConects && objectConects.length > 0) {
            objectConects.forEach((obj: any) => {
                const featureId = obj.featureId;
                const fileName = obj.file;
                const guid = obj.guid;
                if (!show) {
                    this.contextMenu!.conditionShowOff.push([`\${batchId}===${featureId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, 'false']);

                } else {
                    // Xóa điều kiện khỏi danh sách nếu isShow là true
                    this.contextMenu!.conditionShowOff = this.contextMenu!.conditionShowOff.filter(
                        ([condition]) => !condition.includes(`\${batchId}===${featureId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`)
                    );
                }

            })
        }


    }
    //#region _handleShowOffForParent
    private _handleShowOffForParent = async (dataView: any, show: boolean) => {
        if (!this.listKeyMapObject) {
            return;
        }
        // console.time('update-hide-parent')
        if (!show) {
            this.contextMenu!.conditionShowOff = [...this.contextMenu!.conditionShowOff, ...dataView.conditionShowOff]
            this._buttonsMapHide.set(dataView.objectId, dataView)

        } else {
            //  Xóa điều kiện khỏi danh sách nếu isShow là true
            this.contextMenu!.conditionShowOff = this.contextMenu!.conditionShowOff.filter(
                (item) => !dataView.conditionShowOff.some((condition: [string, string]) => condition[0] === item[0] && condition[1] === item[1])
            );
            this._buttonsMapHide.delete(dataView.objectId)

        }

        if (!dataView.dataPoint.childrenUsed) return

        for (let i = 0; i < dataView.dataPoint.childrenUsed.length; i++) {
            const child = dataView.dataPoint.childrenUsed[i];
            const model = this.treeLayerModels.find((item: any) => item.objectId === child.objectId);
            if (model) {
                model.isShow = show;
            }
            if (!show) {
                this._buttonsMapHide.set(child.objectId, child)
            } else {
                this._buttonsMapHide.delete(child.objectId)
            }
        }


        this._list?.refresh(this.containerUl!, this._config)
        // console.timeEnd('update-hide-parent')
    }

    //#region handleShowAll
    handleShowAllElement = () => {
        if (!this.isOpenModal) return
        this._buttonsMapHide.forEach((value, key) => {
            value.isShow = true;
        });

        this._buttonsMapHide.clear()

        this.handleRefreshList()
        // console.timeEnd('show-all')

    }


    //#region _handleIsolate
    private _handleIsolate = (data: any) => {
        this.contextMenu!.isLoadFromShow = true
        this.contextMenu!.conditionsIsolate = [] // Xóa điều kiện cũ
        const containerBtn = document.getElementById(`${this._idTreeView}`)
        data.forEach((item: any) => {
            const objectConects = this.listKeyMapObject![item.objectId]?.objectConnects ?? null

            if (objectConects) {
                // Tìm button liên quan đến child này
                const button = containerBtn?.querySelector<HTMLElement>(`div[data-folder-id="${item.objectId}"]`);
                const text = containerBtn?.querySelector<HTMLElement>(`span[data-layer-text-id="${item.objectId}"]`);
                if (button && text) {
                    item.isShow = true
                    button.innerHTML = IconEyeShow()
                    text.style.removeProperty('opacity')
                }
                objectConects.forEach((obj: any) => {
                    const featureId = obj.featureId;
                    const fileName = obj.file;
                    const guid = obj.guid;
                    this.contextMenu!.conditionsIsolate.push([`\${batchId}===${featureId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, 'color("rgba(255,255,255,1)")']);


                })
            }
        })

        this.contextMenu!.conditionsIsolate = this.contextMenu!.conditionsIsolate.filter(
            ([key, value]) => !(key === "true" && value === "true")
        );
        // Điều kiện 2: Đối tượng không thỏa mãn điều kiện trên sẽ có độ trong suốt 50%
        this.contextMenu!.conditionsIsolate.push(["true", `color("${colorIsolate}")`]);    // Đổi màu với alpha 0.5`

        // if (this.contextMenu!.conditionShowOff.length > 0) {
        //     this.contextMenu!.conditionShowOff.push(['true', 'true'])
        // }



    }
    private _handleIsolateForParent = async (dataView: any) => {
        //update-icons: 1912.396240234375 ms
        this.contextMenu!.isLoadFromShow = true
        this.contextMenu!.conditionsIsolate = [] // Xóa điều kiện cũ
        const containerBtn = document.getElementById(`${this._idTreeView}`)

        const button = containerBtn?.querySelector<HTMLElement>(`div[data-folder-id="${dataView.objectId}"]`);
        const text = containerBtn?.querySelector<HTMLElement>(`span[data-layer-text-id="${dataView.objectId}"]`);

        if (button && text) {
            dataView.isShow = true
            button.innerHTML = IconEyeShow()
            text.style.removeProperty('opacity')
        }

        if (this.isFilterTree && !dataView.dataPoint) {
            await this._filterTree?.computeGlobalPointAndCondition(dataView)
        }
        if (!dataView.dataPoint.childrenUsed) return
        for (let i = 0; i < dataView.dataPoint.childrenUsed.length; i++) {
            const child = dataView.dataPoint.childrenUsed[i];
            const button = this._buttonsMapHide.get(child.objectId)
            if (button) {
                child.isShow = true
                // button.innerHTML = IconEyeShow()
            }
        }



        this.contextMenu!.conditionsIsolate = [...dataView.conditionIsolate]
        // Điều kiện 2: Đối tượng không thỏa mãn điều kiện trên sẽ có độ trong suốt 50%
        this.contextMenu!.conditionsIsolate.push(["true", `color("${colorIsolate}")`]);    // Đổi màu với alpha 0.5`

        this._list?.refresh(this.containerUl!, this._config)
        // this.handleRefreshList()    
        // console.timeEnd('isolate-parrent')
    }

    //#region _getItemsTreeByParentId
    //Tìm Item trong List theo parent
    getItemsTreeByParentId = (data: any, parentId: string) => {
        const result = [];
        const stack = [parentId]; // Sử dụng stack để duyệt qua tất cả các cấp

        while (stack.length > 0) {
            const currentParentId = stack.pop();
            // Lấy tất cả các phần tử có parentId khớp
            const children = data.filter((item: any) => item.parent === currentParentId);

            // Thêm các phần tử vào kết quả
            result.push(...children);

            // Đưa id của từng phần tử vào stack để kiểm tra cấp con tiếp theo
            children.forEach((child: any) => stack.push(child.objectId));
        }

        return result;
    }


    //#region _computeGlobalMinMaxPoints
    private _computeGlobalMinMaxPoints = (
        dataView: any,
    ) => {
        try {
            const minPoints: Cartesian3[] = [];
            const maxPoints: Cartesian3[] = [];
            const childrenUsed: any[] = [];
            const dfs = (current: any) => {
                // Đệ quy trước
                if (current.childrenObject && current.childrenObject.length > 0) {
                    for (const child of current.childrenObject) {
                        dfs(child);
                    }
                }

                // Sau đó mới xét chính nó
                const data = this.listKeyMapObject?.[current.objectId]?.objectConnects;
                if (data && data.length > 0) {
                    const pointObj = this.computeBoundingBoxFromFeatureObjects(data); // kiểm tra xem nó có nhiều maxPoint minPoint
                    if (pointObj) {
                        minPoints.push(Cartesian3.fromArray(pointObj.minPoint));
                        maxPoints.push(Cartesian3.fromArray(pointObj.maxPoint));
                    }
                }
                childrenUsed.push(current);
            };

            dfs(dataView);

            if (minPoints.length === 0 || maxPoints.length === 0) {
                throw new Error("Không tìm thấy min/max point nào từ cây đối tượng.");
            }
            let disparityCood = [0, 0, 0]
            let urlFinded
            if (childrenUsed.length > 0 && !urlFinded) {
                for (const item of childrenUsed) {
                    const keyObj = this.listKeyMapObject?.[item.objectId];
                    if (keyObj) {
                        urlFinded = keyObj.primitive.resource?.url
                        disparityCood = [...this._handleDisparityCoord(urlFinded, keyObj.originalBoundingBox)]

                        break;
                    }
                }

            }

            let minX = Infinity, minY = Infinity, minZ = Infinity;
            let maxX = -Infinity, maxY = -Infinity, maxZ = -Infinity;

            for (const p of minPoints) {
                if (p.x < minX) minX = p.x;
                if (p.y < minY) minY = p.y;
                if (p.z < minZ) minZ = p.z;
            }
            for (const p of maxPoints) {
                if (p.x > maxX) maxX = p.x;
                if (p.y > maxY) maxY = p.y;
                if (p.z > maxZ) maxZ = p.z;
            }

            const globalMin = new Cartesian3(minX, minY, minZ);
            const globalMax = new Cartesian3(maxX, maxY, maxZ);

            if (urlFinded) {
                globalMin.x = globalMin.x + disparityCood[1]
                globalMin.y = globalMin.y + disparityCood[0]
                globalMin.z = globalMin.z + disparityCood[2]

                globalMax.x = globalMax.x + disparityCood[1]
                globalMax.y = globalMax.y + disparityCood[0]
                globalMax.z = globalMax.z + disparityCood[2]
            }

            return { min: globalMin, max: globalMax, childrenUsed, };
        } catch (err) {
            return false
        }

    };

    //#region computeBoundingBoxFromFeatureObjects
    computeBoundingBoxFromFeatureObjects = (
        featureList: any[]
    ): { minPoint: [number, number, number]; maxPoint: [number, number, number] } | null => {
        if (!featureList || featureList.length === 0) return null;

        const valid = featureList.filter(f =>
            f.minPoint?.length === 3 &&
            f.maxPoint?.length === 3 &&
            f.minPoint.every((v: any) => Number.isFinite(v)) &&
            f.maxPoint.every((v: any) => Number.isFinite(v))
        );

        if (valid.length === 0) return null;

        const minPoint: [number, number, number] = [
            Math.min(...valid.map(f => f.minPoint![0])),
            Math.min(...valid.map(f => f.minPoint![1])),
            Math.min(...valid.map(f => f.minPoint![2]))
        ];

        const maxPoint: [number, number, number] = [
            Math.max(...valid.map(f => f.maxPoint![0])),
            Math.max(...valid.map(f => f.maxPoint![1])),
            Math.max(...valid.map(f => f.maxPoint![2]))
        ];

        return { minPoint, maxPoint };
    };



    //#region handleHideElement
    handleHideElement = async (objectOffs: any[]) => {
        if (this.isOpenModal) {
            // console.time('hide-context')
            const containerBtn = document.querySelector(`#${this._idTreeView}`);

            // Loại bỏ các phần tử trùng lặp bằng Set
            const uniqueObjectOffs = [...new Set(objectOffs)];
            const listFoldelModel: any = []
            for (const item of uniqueObjectOffs) {
                const objs = this.listKeyMapObject?.[item];
                if (objs) {
                    for (const model of this.treeLayerModels) {
                        if (model.primitiveName === objs.folder) {
                            const check = listFoldelModel.find((x: any) => x.objectId === model.objectId);
                            if (!check) {
                                listFoldelModel.push(model);
                            }
                        }
                    }
                }
            }
            if (listFoldelModel.length > 0) {
                for (const model of listFoldelModel) {
                    const findPrimitive = this._primitiveNames.find((item: any) => item === model?.primitiveName)
                    //Kiểm tra xem primitive có tồn tại không
                    if (!findPrimitive) {
                        const parentsData = this._findParents(this.treeLayerModels, model.objectId).reverse()
                        parentsData.forEach(async (parent: any) => {

                            if (!parent.expand) {
                                const arrow = containerBtn?.querySelector(`[data-layer-id="${parent.objectId}"]`)?.querySelector(".arrow-icon") as HTMLSpanElement
                                if (arrow) {
                                    arrow?.click()

                                } else {
                                    parent.expand = true
                                    this.handleDisplayItem(parent)
                                    this._config.total = this.listDisplayItem.length
                                    this._list?.refresh(this.containerUl!, this._config)
                                }
                            }
                        })
                        const arrowLoadApi = containerBtn?.querySelector(`div[data-layer-id="${model.objectId}"]`)?.querySelector(".arrow-icon") as HTMLSpanElement
                        if (arrowLoadApi) {
                            arrowLoadApi.click()

                        } else {
                            const result = await this._handleCallApiTree(model)
                            if (result) {
                                model.expand = true
                                this._calConditionForTree()
                                this.handleDisplayItem(model)
                                this._config.total = this.listDisplayItem.length
                                this._list?.refresh(this.containerUl!, this._config)

                            }
                        }
                    }
                }
            }

            uniqueObjectOffs.forEach((item: any) => {
                const findItem = this.treeLayerModels.find((x: any) => x.objectId === item)
                if (findItem) {
                    findItem.isShow = false
                    //bật tất cả thằng cha
                    this._buttonsMapHide.set(item, findItem)
                }
            })

            this._list?.refresh(this.containerUl!, this._config)
            // console.timeEnd('hide-context')
        }



    }

    //#region _calconditionForTree
    //hàm Tính toán lại Codition,Boudingbix cho các mục
    private _calConditionForTree = () => {

        this.treeLayerModels.forEach((item: any) => {
            if (item.childrenObject?.length > 0) {
                const pointParent = this._computeGlobalMinMaxPoints(item)
                if (pointParent) {
                    item.dataPoint = pointParent

                    item.conditionIsolate = []
                    item.conditionShowOff = []
                    pointParent.childrenUsed.forEach((child) => {
                        const objectConects = this.listKeyMapObject![child.objectId]?.objectConnects ?? null
                        objectConects?.forEach((obj: any) => {
                            const featureId = obj.featureId;
                            const fileName = obj.file;
                            const guid = obj.guid;
                            item.conditionIsolate.push([`\${batchId}===${featureId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, 'color("rgba(255,255,255,1)")']);
                            item.conditionShowOff.push([`\${batchId}===${featureId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, 'false']);
                        })
                    })

                }
            }
        })
    }
    //#region _normalizeSVGString
    private _normalizeSVGString = (svgString: string): string => {
        return svgString
            .replace(/\s+/g, " ")             // gộp nhiều khoảng trắng thành 1
            .replace(/\s*(xmlns:[^=]+)="[^"]*"/g, "") // bỏ xmlns
            .trim();
    }
    //#region _actionCheckCoditionContextMenu
    private _actionCheckCoditionContextMenu = async () => {
        const check = this.contextMenu!.tempCondition

        if (check.conditionShow?.length > 0) {
            const list = this._getGuidList(check.conditionShow)
            if (list.length > 0) {
                await this.handleHideElement(list)


            }
        } else {
            this._actionShowAllBtn()
        }

    }
    //#region _actionShowAllBtn
    private _actionShowAllBtn = () => {
        this._buttonsMapHide.forEach((value, key) => {
            // dataBtn.button.innerHTML = IconEyeShow()
            value.isShow = true

        })
        this._buttonsMapHide.clear()
    }

    private _getGuidList = (arr2D: [string, string][]): string[] => {
        const guidRegex = /\$\{guid\}==='(.*?)'/g;
        const result: string[] = [];

        arr2D.forEach((innerArr) => {
            innerArr.forEach((item) => {
                let match;
                while ((match = guidRegex.exec(item)) !== null) {
                    result.push(match[1]);
                }
            });
        });

        return result;
    }

    //#region _findParents
    //Hàm tìm cha của một đối tượng trong mảng phẳng
    private _findParents(flatArray: any[], objectId: any) {
        const parents = [];
        let current = flatArray.find(item => item.objectId === objectId);

        while (current && current.parent) {
            const parent = flatArray.find(item => item.objectId === current.parent);
            if (parent) {
                parents.push(parent);
                current = parent;
            } else {
                break;
            }
        }

        return parents;
    }
    //#region _handleRefreshList 
    handleRefreshList = () => {
        if (this.containerUl && !this._list) {
            // const height = this.containerUl?.getBoundingClientRect().height || window.innerHeight;
            this._config.total = this.treeLayerModels.length
            this._list = new HyperList(this.containerUl!, this._config)
        }


        this._config.total = this.listDisplayItem.length
        this._list?.refresh(this.containerUl!, this._config)
    }

    //#region Feature filtertree
    storageTreeLayerModels: any[] = []
    storageListDisplayItem: any[] = []
    isFilterTree = false
    primitiveNameFilters: string[] = []
    private _filterTree: FilterTree | undefined = undefined
    //#region _handleFilterTree
    private _handleFilterTree = async () => {
        this.isFilterTree = true
        if (this.storageTreeLayerModels.length === 0 || this.storageListDisplayItem.length === 0) {
            this.storageTreeLayerModels = [...this.treeLayerModels];
            this.storageListDisplayItem = [...this.listDisplayItem];
        }
        this.treeLayerModels = [];
        this.listDisplayItem = [];
        if (!this._filterTree) {

            this.primitiveNameFilters = this.inputDataPrimitive?.ObjDataPrimitive.map((item: ObjDataPrimitiveModel) => item.data?.folder as string) || [];

            this._filterTree = new FilterTree(
                this
            )

        } else {
            this._filterTree.formFilterTreeLayer?.showHideModel(true)
        }
    }
    //#endregion


    private _containerLoading: HTMLDivElement | undefined = undefined
    private _containerBodyDialog: HTMLDivElement | undefined = undefined
    fetchLoading = (isLoading: boolean) => {
        if (!this._containerLoading || !this._containerBodyDialog) {
            this._containerBodyDialog = document.getElementById(`dialog-body-${this.dialog?.IdGenneral}`) as HTMLDivElement;
            this._containerLoading = document.createElement('div');
            this._containerLoading.style.cssText = "position: absolute;top:0;width: 100%;height: 100%;background-color: rgba(255, 255, 255, 0.2);z-index: 9999;";

            this._containerLoading.innerHTML = `<div style="display:flex;justify-content:center;align-items:center ;height: 100%;"><img class = "dpu-loading-animation" src="${loading}" alt="Loading..." width="35" height ="35"  style="pointer-events: none;"/></div>`
        }
        if (isLoading) {
            this._containerBodyDialog.style.position = 'relative';
            this._containerBodyDialog?.appendChild(this._containerLoading);
        } else {
            this._containerBodyDialog?.style.removeProperty('position');
            this._containerBodyDialog?.removeChild(this._containerLoading);

            // this._containerLoading?.remove();
        }

    }

}


